import { call, put, takeEvery } from 'redux-saga/effects';
import { axiosInstance, updatedAccessToken } from '../api';
import { ERROR, GET_ALL_USERS_SUCCESS, LOADER, GET_ALL_USERS, TOKEN_EXPIRED } from "../actions/types";

function getcustomerSuggestionApi(action) {
    let apiUrl1 = `usermanagement?roleid=${action.payload.roleID}`;
    return axiosInstance.get(apiUrl1, { headers: updatedAccessToken() })
}

function* getAllUsersApi(action) {
    try {
        yield put({
            type: LOADER,
            payload: true,
        });
        const response = yield call(() => getcustomerSuggestionApi(action));
        yield put({
            type: LOADER,
            payload: false,
        });
        if (response?.data?.statusCode === 200) {
            yield put({ type: GET_ALL_USERS_SUCCESS, response: response.data })
        } else {
            yield put({
                type: LOADER,
                payload: false,
            });
            yield put({
                type: ERROR,
                payload: response.data.body.message,
            });
        }
    } catch (err) {

        if (err.response?.status === 403) {
            yield put({
                type: TOKEN_EXPIRED,
                payload: true,
            });

            setTimeout(() => {
                window.location.reload();
            }, 3000)
        }
        else {
            yield put({
                type: ERROR,
                payload: err.message,
            });
        }
        yield put({
            type: LOADER,
            payload: false,
        });
    }
}

function* getAllUsers() {
    yield takeEvery(GET_ALL_USERS, getAllUsersApi)
}

const manageUserSaga = {
    getAllUsers: getAllUsers()
}

export default manageUserSaga;